import type { IconSvgObject } from './types';

const ChevronUpIcon: IconSvgObject = [
  ["path", { d: "M18 15C18 15 13.5811 9.00001 12 9C10.4188 8.99999 6 15 6 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ChevronUpIcon;
